import { createGlobalInstance } from '@campai/lib-web/utils/state'
import { initWebAppState } from '@campai/lib-web/appState'

import { AppState } from './AppState'

export const appState = createGlobalInstance('appState', () => new AppState())

export const initAppState = async () => {
    initWebAppState(appState)
    await appState.init()
}
